// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"43b4b21d","732":"7721696b","977":"00e205cd"}[chunkId] + ".chunk.js";
};